import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { OroLoaderInline, Page } from "../../core";
import {
  getAllBonds,
  getConsolidatedPortfolio,
  getRedeemRequests,
  getTimeline,
} from "../services/waitlist-service";
import ReactGA from "react-ga4";
import ObPfHoldings from "./ObPfHoldings";
import ObPortfolioPfCard from "./ObPortfolioPfCard";
import ObRecentTransaction from "./ObRecentTransaction";
import MldHoldingsd from "./MldHoldings";
import Sticky from "react-sticky-el";
import { Button, Nav, NavItem, NavLink } from "reactstrap";
import LiquidationCard from "./LiquidationCard";
import money from "../assets/images/Kundi.png";
import { setAnalyticsEvent } from "../../core/helpers/analytics";
import MaturedCard from "./MaturedCard";
import { utils } from "../../core/helpers/utils";

export default function OrobondsPortfolioMain() {
  const [isMobile, setIsMobile] = useState(false);
  const [products, setProducts] = useState([]);
  const [holdings, setHoldings] = useState({});
  const [bondDetails, setBondDetails] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [loader, setLoader] = useState(false);
  const [transaction, setTransaction] = useState([]);
  const [txLoader, setTxLoader] = useState(true);
  const [activeTab, setActiveTab] = useState("current");
  const [pendingRequests, setPendingRequests] = useState([]);
  const [completedRequests, setCompletedRequests] = useState([]);
  const [maturedDeals, setMaturedDeals] = useState([]);

  useEffect(() => {
    const locationHash = window.location.hash;
      ReactGA.send({ hitType: 'pageview', page_location: `${locationHash}` });
      { process.env.REACT_APP_RENDER_GA === "true" &&
        setAnalyticsEvent(locationHash, `${locationHash}`);
      }
    setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    setLoader(true);
    setTxLoader(true);
    getConsolidatedPortfolio().then((result) => {
      const response = utils.parsePayload(result);

      if (!response || !response.success) {
        return toast.error(
          response.message
        );
      }

      if (response.data && response.data.consolidated) {
        let arrPortfolio = [
          {
            title: "Current Value",
            value:
              (response.data &&
              response.data.consolidated &&
              response.data.consolidated.mtm
                ? (response.data.consolidated.mtm).oroNumber(2, true)
                : 0),
          },
          {
            title: "Payouts",
            value:
              (response.data &&
              response.data.consolidated &&
              response.data.consolidated.coupons
                ? (response.data.consolidated.coupons).oroNumber(2, true)
                : 0),
          },
          {
            title: "Amount Invested",
            value:
              (response.data &&
              response.data.consolidated &&
              response.data.consolidated.userInvestedAmnt
                ? (response.data.consolidated.userInvestedAmnt).oroNumber(2, true)
                : 0),
          },
          // {
          //   title: "Bidd Benefit",
          //   value: (response.data && response.data.consolidated &&
          //         response.data.consolidated.benefit ?
          //         (response.data.consolidated.benefit.total).oroNumber(2, true) : 0),
          // },
        ]
        let newArr = arrPortfolio.filter(obj => obj.title === "Coupons" && obj.value === 0 ? null : obj)
        setPortfolio(newArr)
      }

      setHoldings({ ...response.data.holdings });
      return getAllBonds().then((result) => {
        const bonds = utils.parsePayload(result);
        setLoader(false);
        if (!bonds || !bonds.success) {
          setTxLoader(false);
          return toast.error("Error: Unable to fetch bonds details");
        }
        if (bonds && bonds.data && bonds.data.length) {
          setBondDetails([...bonds.data]);
          return getTimeline(
            { "X-product": "orobonds:default" },
            { consolidated: true }
          ).then((result) => {
            const response = utils.parsePayload(result);
            setTxLoader(false);
            if (!response || !response.success) {
              toast.error(
                response.message || "Error: Unable to fetch transaction details"
              );
            }
            if (response.data && response.data.length) {
              setTransaction([...response.data]);
            }
          });
        }
      });
    });
  }, []);

  useEffect (() => {
    getRedeemRequests().then(
      (res) => {
        if (!res.success) {
          return null
        }

        if (res && res.success && res.data && res.data.length) {
          filterRequests(res.data);
        }
      }
    );
  },[])

  useEffect (() => {
    let tmpMatured = [];
    let obj = Object.keys(holdings)?.forEach((element) => {
      if (holdings[element].pfStats.matured) {
        tmpMatured.push(holdings[element])
      }
    });
    setMaturedDeals(tmpMatured);
  },[holdings])

  const redirectToBrowse = () => {
    window.location.href = "/platform/#/";
  }

  const filterRequests = (data) => {
    setPendingRequests(
      data.filter((d)=> d.currentState.state === "RA" || d.currentState.state === "SA")
    );
    setCompletedRequests(
      data.filter((d)=> d.currentState.state === "RP")
    )
  }

  const toggle = (tab) => {
    setActiveTab(tab);
  };

  const getTabElement = (tab) => {
    switch (tab) {
      case "current":
        return (
          <div className="flex-column w-100">
          <>
          { !loader && bondDetails.length ?
          <>
          { (portfolio?.length && bondDetails?.length) ? 
            <>
            {portfolio.length ? (
              <>
                <div className="w-100" style={{marginTop: "6rem"}}></div>
                <ObPortfolioPfCard portfolio={portfolio} />
              </>
            ) : null}

            {!loader && bondDetails.length ? (
              <ObPfHoldings
                isMobile={isMobile}
                holdings={holdings}
                products={products}
                bondDetails={bondDetails}
              />
            ) : (
              <div className="w-100 mb-5">
                <OroLoaderInline />
              </div>
            )}
            {!loader && bondDetails.length ? (
              <MldHoldingsd
                isMobile={isMobile}
                holdings={holdings}
                products={products}
                bondDetails={bondDetails}
              />
            ) : (
              <div className="w-100 mb-5">
                <OroLoaderInline />
              </div>
            )}
            </> : 
            <div className="no-portfolio">
              <p className="text-center font-weight-semi-bold header">Your portfolio is Empty</p>
              <div className='btn-holder'>
                <Button className='btn-1' secondary onClick={redirectToBrowse}>Invest Now</Button>
              </div>
              <img src={money} alt="money" className="mt-2"/>
            </div>
          } </> : 
          <div className="w-100 mt-5 pt-5">
            <OroLoaderInline />
          </div>
          }

            {!txLoader && transaction.length ? (
              <ObRecentTransaction
                transaction={transaction}
                bonds={bondDetails}
                isMobile={isMobile}
              />
            ) : (
              <div className="w-100 mt-5 pt-5">
                <OroLoaderInline />
              </div>
            )}
          </>
          </div>
        );
      case "pending":
        return <LiquidationCard 
            isMobile={isMobile} 
            bondDetails={bondDetails}
            requests={pendingRequests}
          />;
      case "complete":
        return <LiquidationCard 
          isMobile={isMobile} 
          bondDetails={bondDetails}
          requests={completedRequests}
        />;
      case "matured":
        return <MaturedCard 
          isMobile={isMobile} 
          bondDetails={bondDetails}
          requests={maturedDeals}
        />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <Page className="obPortfolio-main">
        {(
          <Sticky className="sticky-tabs-mf">
            <Nav tabs className="portfolio-subheader">
              <NavItem className="item">
                <NavLink
                  className="link text-muted"
                  onClick={() => toggle("current")}
                  style={
                    activeTab === "current"
                      ? {
                          borderBottom: "4px solid #283A97",
                          color: "#283A97",
                        }
                      : {}
                  }
                >
                  Current Portfolio
                </NavLink>
              </NavItem>
              {(pendingRequests && pendingRequests.length) ? (
                <>
                  <div className="vr"></div>
                  <NavItem className="item">
                    <NavLink
                      className="link text-muted"
                      onClick={() => toggle("pending")}
                      style={
                        activeTab === "pending"
                          ? {
                              borderBottom: "4px solid #283A97",
                              color: "#283A97",
                            }
                          : {}
                      }
                    >
                      Liquidation Pending
                    </NavLink>
                  </NavItem>
                </>
              ) : null}
              {(completedRequests && completedRequests.length) ? (
                <>
                  <div className="vr"></div>
                  <NavItem className="item">
                    <NavLink
                      className="link text-muted"
                      onClick={() => toggle("complete")}
                      style={
                        activeTab === "complete"
                          ? {
                              borderBottom: "4px solid #283A97",
                              color: "#283A97",
                            }
                          : {}
                      }
                    >
                      Liquidation Completed
                    </NavLink>
                  </NavItem>
                </>
              ) : null}
              {maturedDeals && maturedDeals.length ?
                <>
                  <div className="vr"></div>
                  <NavItem className="item">
                    <NavLink
                      className="link text-muted"
                      onClick={() => toggle("matured")}
                      style={
                        activeTab === "matured"
                          ? {
                              borderBottom: "4px solid #283A97",
                              color: "#283A97",
                            }
                          : {}
                      }
                    >
                      Matured Investments
                    </NavLink>
                  </NavItem>
                </>
                : null
              }
            </Nav>
          </Sticky>
        )}
        <div className="flex-column w-100">
          {getTabElement(activeTab)}
        </div>
      </Page>
    </>
  );
}
